<template>
  <div class="time-left">
    <h1 class="text-time">{{ mins }}:{{ secs }}</h1>
  </div>
</template>

<script>
export default {
  computed: {
    time() {
      if (this.miliseconds < 0) {
        return 0;
      }
      return this.miliseconds;
    },
    mins() {
      if (this.seconds === '60') {
        return `${parseInt(this.minutes, 10) + 1}`.padStart(2, '0');
      }
      return this.minutes;
    },
    secs() {
      if (this.seconds === '60') {
        return '00';
      }
      return this.seconds;
    },
    minutes() {
      return `${Math.floor((this.time / 1000) / 60)}`.padStart(2, '0');
    },
    seconds() {
      return `${((this.time / 1000) % 60).toFixed(((this.time / 1000) < 10) ? 2 : 0)}`.padStart(2, '0');
    },
  },
  name: 'TimeLeft',
  props: {
    miliseconds: Number,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.text-time {
  font-size: 50px !important;
  line-height: 50px !important;
  margin-bottom: 0;
  margin-top: 4px;
  font-weight: 500;
}
</style>
